<template>
  <section id="news_details">
    <div class="slider">
      <VueSlickCarousel :arrows="false" :dots="false" :autoplay="true" v-if="card.images.length>0" ref="carousel" v-bind="settings">
        <!--        <div :class="'slide'+i" class="container-fluid" v-for="(item, i) in $t('carousel')" :key="i"></div>-->
        <div v-for="(img,i) in card.images" :key="i">
          <div class="slider_image" :style="{ 'background': 'url( ' + baseUrl + img.image + ') no-repeat center center'}" role="img" :aria-label="card.title"></div>
        </div>
      </VueSlickCarousel>
      <a class="prev d-flex justify-content-center align-items-center" v-on:click="prev">
        <img src="../../assets/icons/left_white.svg">
      </a>
      <a class="next d-flex justify-content-center align-items-center" v-on:click="next">
        <img src="../../assets/icons/right_white.svg">
      </a>
    </div>
    <div class="info">
      <div class="row mx-md-5 mx-4 py-5">
        <div class="col-12">
          <!--          <div class="title pb-4"> {{$t('news.news[' + id + '].card_title')}}</div>-->
          <h1 class="title pb-4"> {{card.title}} </h1>
        </div>
        <div class="col-12">
          <!--          <div class="description"> {{$t('news.news[' + id + '].card_description')}} </div>-->
          <p class="description"> {{card.created_at}} </p>
        </div>
        <div class="col-12 py-4">
          <!--          <div class="body"> {{$t('news.news[' + id + '].body')}} </div>-->
          <p class="body"> {{card.description}} </p>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import $ from 'jquery'
import NewsRepository from '../../Repositories/NewsRepository'
import Constants from '../../Plugins/Constants'

export default {
  name: 'NewsDetails',
  data () {
    return {
      title: 'Default value',
      id: 0,
      // results: [],
      // numPages: 0,
      // page: 1,
      // per_page: 4,
      card: {
        title: '',
        description: '',
        created_at: '',
        images: []
      },
      show: [],
      settings: {
        fade: true,
        // speed: 600
        speed: 500,
        autoPlay: true,
        autoplaySpeed: 3500,
        pauseOnHover: false
      },
      baseUrl: Constants.baseUrl,
      NewsRepo: new NewsRepository()
    }
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: { VueSlickCarousel },
  methods: {
    // async getPage (slideIndex) {
    //   // console.log('our carousel is ready', slideIndex)
    //   const x = await this.NewsRepo.getPage(this.page)
    //   // console.log('our carousel is ready', x)
    //   this.results = x.content
    //   // this.page ===+ 1
    //   // console.log('results-newsss', this.results)
    //   // console.log('results-images', '+ this.baseUrl + results[1].images[1].image +')
    // },
    async get_single_news (id) {
      // console.log('kk', this.section)
      const response = await this.NewsRepo.getSigleNewsById(id)
      this.card = response.data.body
      this.title = this.card.title
      // console.log('tata', this.card)
      // console.log('tata', typeof this.card.images)
    },
    prev () {
      this.$refs.carousel.prev()
    },
    next () {
      this.$refs.carousel.next()
    }
  },
  created () {
    // this.getPage(1)
    this.id = this.$route.params.newsId
    if (this.id !== 0) {
      this.get_single_news(this.id)
    }
  },
  mounted () {
    // console.log('hi1', this.id)
    if (localStorage.getItem('lang') === 'ar') {
      $('#news_details').css('direction', 'rtl')
      $('#news_details .title, #news_details .description').css('text-align', 'right')
    } else {
      $('#news_details').css('direction', 'ltr')
      $('#news_details .title, #news_details .description').css('text-align', 'left')
    }
  }
}
</script>

<style lang="scss">
@import "src/scss/main";
#news_details {
  overflow: hidden;
  text-underline-position: under!important;
}
#news_details .slider {
  position: relative;
  //height: 60vh;
  height: 69vh;
  z-index: 300;
}
#news_details .slider_image {
  height: 69vh;
  //background: url("../../assets/images/carousel2.png") no-repeat center center;
  background-size: cover!important;
}
#news_details .slick-prev:before {
  content: url("../../assets/icons/left_service.svg");
  -webkit-transition: transform .2s ease-in-out;
  position: absolute;
  //bottom: -48vh;
  left: 3vh!important;
}
#news_details .slick-prev, #news_details .slick-next {
  z-index: 10000;
}
#news_details .slick-next:before {
  content: url("../../assets/icons/right_service.svg");
  -webkit-transition: transform .2s ease-in-out;
  position: absolute;
  //bottom: -48vh;
  right: 3vh!important;
}
#news_details .title {
  color: $buttonorange;
  font-size: 29.7px;
  font-family: Messiri-Bold;
  text-decoration: underline;
  width: 40%;
}
#news_details .description {
  color: $definitionblue;
  font-family: Messiri-SemiBold;
  font-size: 13.2px;
  border-bottom: 1.5px solid;
}
#news_details .body {
  color: $single_page_black;
  font-size: 14.52px;
  text-align: justify;
}
#news_details .info {
  background: $lightGray;
  width: 100%;
  margin-top: -5vh;
  z-index: 400;
  position: absolute;
  //border: 4px solid rgba(255,255,255,0.4);
  //box-shadow: inset 2px 2px 5px 2px rgba(255,255,255,0.4);
  box-shadow: 2px 2px 1px rgba(255,255,255,0.4), -2px -2px 1px rgba(255,255,255,0.8);
  border-radius: 10px;
  filter:  drop-shadow(15px 15px 20px rgba(0, 0, 0, 0.3));
  -webkit-filter:  drop-shadow(15px 15px 20px rgba(0, 0, 0, 0.3));
  -moz-filter:  drop-shadow(15px 15px 20px rgba(0, 0, 0, 0.3));
  -o-filter:  drop-shadow(15px 15px 20px rgba(0, 0, 0, 0.3));
  min-height: 36vh;
}
#news_details .prev {
  top: 40%;
  margin-top: 18.5px;
  left: 0px;
  position: absolute;
  width: 43.56px;
  height: 81.84px;
  //background-color: rgba(255,255,255,0.4) !important;
  //backdrop-filter: blur(11px) opacity(1);
  //-webkit-backdrop-filter: blur(11px) opacity(1);
  //-moz-backdrop-filter: blur(11px) opacity(1);
  //-o-backdrop-filter: blur(11px) opacity(1);
  background-color: rgba(0,0,0,0.2) !important;
  backdrop-filter: blur(11px) opacity(1);
  -webkit-backdrop-filter: blur(11px) opacity(1);
  -moz-backdrop-filter: blur(11px) opacity(1);
  -o-backdrop-filter: blur(11px) opacity(1);
  cursor: pointer;
}
#news_details .next {
  top: 40%;
  margin-top: 18.5px;
  right: 0;
  position: absolute;
  width: 43.56px;
  height: 81.84px;
  background-color: rgba(0,0,0,0.2) !important;
  backdrop-filter: blur(11px) opacity(1);
  -webkit-backdrop-filter: blur(11px) opacity(1);
  -moz-backdrop-filter: blur(11px) opacity(1);
  -o-backdrop-filter: blur(11px) opacity(1);
  cursor: pointer;
}
#news_details .next img, #news_details .prev img {
  width: 8.811px;
  height: 17.6px;
  //width: 13.35 vmin;
  //height: 26.7 vmin;
}
@media screen and (max-width: 768px) {
  //#news_details .title {
  //  font-size: 5.2vmin;
  //}
  //#news_details .description {
  //  font-size: 3vmin;
  //}
  //#news_details .body {
  //  font-size: 3.2vmin;
  //}
  //#news_details .title {
  //  width: 80%;
  //}
  //#news_details .prev, #news_details .next {
  //  width: 8.6vmin;
  //  height: 14.4vmin;
  //}
  //#news_details .next img, #news_details .prev img {
  //  width: 2.335vmin;
  //  height: 3.67vmin;
  //}
}
@media screen and (max-width: 480px) {
  #news_details .slider_image, #news_details .slider {
    height: 45vh;
  }
  #news_details .info {
    min-height: 60vh;
  }
  #news_details .title {
    width: 100%;
  }
}
@media screen and (min-width: 480px) and (max-width: 768px) {
  #news_details .title {
    width: 65%;
  }
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  //#news_details .title {
  //  font-size: 4.4vmin;
  //}
  //#news_details .description {
  //  font-size: 2.2vmin;
  //}
  //#news_details .body {
  //  font-size: 2.4vmin;
  //}
  //#news_details .title {
  //  width: 50%;
  //}
  //#news_details .next img, #news_details .prev img {
  //  width: 2.335vmin;
  //  height: 3.67vmin;
  //}
  //#news_details .prev, #news_details .next {
  //  width: 7.6vmin;
  //  height: 13.4vmin;
  //}
  #news_details .title {
    width: 50%;
  }
}
</style>
